import React from "react";
import "./styles.scss";
import { Text, PurchaseButton } from "atoms";
import { ContributeButton } from "atoms";

export default props => {
  return (
    <div className="header-tagline">
      { props.h3 && <Text h3 left text={props.h3}/> }
      { props.h1 && <Text h1 left text={props.h1}/>}
      { props.h5 && <Text h5 left text={props.h5}/>}
      <div className="purchase-buttons">
      { props.purchaseAction && <PurchaseButton dark onClick={props.purchaseAction} /> }
      { props.showBuyMeACoffee && <ContributeButton/> }
      </div>
    </div>
  );
};
